import React from 'react';
import styles from './AboutUs.module.css';
import { Row, Col, Container } from 'reactstrap';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import LeafletMap from '../map/GoogleMap';


function AboutUs() {
  return (
    <footer className={styles.footer} id='GoToAboutUs'>
      <Container fluid>
        <Row>
          <Col xs='12' sm='12' md='6' lg='6'>
            <div className={styles.contactInfo}>
              <h3 className={`${styles.contactTitle} slide-up`}>Contact Us</h3>
              <div className={styles.contactDetails}>
                <div className={`${styles.contactItem} fade-in stagger-1`}>
                  <FiPhone />
                  <span>+91 9595562223</span>
                </div>
                <div className={`${styles.contactItem} fade-in stagger-2`}>
                  <FiMapPin />
                  <span>105,Annapurna Apt., Jay Vishwabharati colony, Garkheda, Chhatrapati Sambhajinagar, Maharashtra, India</span>
                </div>
                <div className={`${styles.contactItem} fade-in stagger-3`}>
                  <FiMail />
                  <span>yogsadhnavarga@gmail.com</span>
                </div>
              </div>
              <div className={`${styles.contactActions} fade-in stagger-4`}>
                <a
                  href="https://maps.google.com/?q=19.86631510722008,75.34184253033385"
                  rel="noopener noreferrer"
                  target="_blank"
                  className={styles.mapLink}
                >
                  <FiMapPin /> Open in Google Maps
                </a>
              </div>
            </div>
          </Col>

          <Col xs='12' sm='12' md='6' lg='6'>
            <div className={`${styles.mapSection} fade-in stagger-2`}>
              <LeafletMap />
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
export default AboutUs;
